import api from './api';

const monthsFallback = {
  today: 1,
  weekly: 1,
  monthly: 12,
  yearly: 12,
};

export async function getDashboard(period = 'monthly') {
  const response = await api.get('/admin/dashboard', {
    params: {
      period,
      months: monthsFallback[period] ?? 12,
    },
  });
  return response.data;
}
